import "./style.scss";
import ProImage from "assets/images/pro.png";
import ProLogo from "assets/icons/proLogo.svg";

const AuthPage = ({}) => {
  
  return <div className="authPage">
    <div className="elements">
      <div className="box title">
        <img src={ProLogo}/>
        <p className="description">
          Experience True DeFi
        </p>
      </div>
      <p className="box closedBeta">
        Closed Beta
      </p>

      <div className="accessCodeBox">
        <input placeholder="Access Code"/>
        <div className="enterBtn">Enter</div>
      </div>

      <div className="box how">
        <p className="howTitle">How to get an access code?</p>
      </div>
    </div>
    
    <img src={ProImage}/>
  </div>
}

export default AuthPage;